<style scoped>
label{
  margin-bottom:0px
}
</style>
<script>
import {
  required,
  requiredIf
} from "vuelidate/lib/validators";
import { notify } from '@/helpers/notify' 

export default {
  name: 'CreateModal',
  props:[
    "list"
  ],
  data() {
    return {
      installment:[],
      installments:[{price:''}],
      installmentTotal:0,
      form:{
        installmentCheck:false,
      },
      burst:{},
      org_form: { 
        type:'',
        invoice_type:'',
        unit:'p',
        commitment_price:0,
        promotion_period:0,
        promotion_price:0,
      },
      submitted: false,
    };  
  },
  validations: {
    form: {
      type: { required },
      invoice_type: { required },
      name: { required },
      time: { 
        required:requiredIf(function(){
            return this.form.invoice_type ==1 || this.form.invoice_type ==4
        }) 
      },
      upload_limit: { required },
      download_limit: { required },
      price: { required },
      unit: { required },
      commitment_price: { 
        required:requiredIf(function(){
            return this.form.invoice_type ==3
        }) 
      },
      promotion_period: { 
        required:requiredIf(function(){
            return this.form.invoice_type ==3
        }) 
      },
      promotion_price: { 
        required:requiredIf(function(){
            return this.form.invoice_type ==3
        }) 
      } 
    },
  },
  watch:{
    list(props){
      this.form = { ...this.org_form }
      this.burst = { ...props.burst }
      if(!props.id) return 
      this.form = {...props,installmentCheck:props.installment && props.installment > 0 ?  true : false}


      let inst = []
      props.installments.map(e => {
        inst.push({price:e.price})
      })

      this.installments = inst
      this.calc()
    }
  },
  filters:{
    fixed(val){
      return val.toFixed(2)
    }
  },
  methods: {
    handleSubmit() {
      this.submitted = true;
      this.$v.$touch();
     if (this.$v.$invalid) {
        return;
      } else {
        if(this.form.id)
          this.update();
        else
          this.create();
      }
      this.submitted = false;
    },
    create(){
      this.$http.post('/tariff/store', { ...this.form, burst: {...this.burst}})
        .then(resp => {
          if(!resp.data.error) this.form = {};

          this.$emit('loadItems');
          return notify.success(resp.data.message)
        })
    },
    update(){
      this.$http.put('/tariff/' + this.form.id ,  { ...this.form, burst: {...this.burst}})
        .then(resp => {
          this.$emit('loadItems');
          return notify.success(resp.data.message)
        })
    },
    remove(id){
      this.$http.delete('/tariff/' + id)
        .then(resp => {
          if(resp.data.code !==  100)  return notify.error(resp.data.message)

           this.$emit('loadItems');
           return notify.success(resp.data.message)
         })
        .catch(error => error)
    },
    close(){
      this.$parent.$bvModal.hide('modal-scoped')
    },
    newLine() {
      this.installments.push({price:''});
    },
    removeLine(index) {
      this.installments.splice(index, 1);
      this.calc()
    },
    thisCopy(){
        delete this.form['id']
        delete this.form['vgt_id']
        delete this.form['name']
        this.form = {...this.form}
    },
    calc(){
      const { installments } = this
      const arr = []
      let toplam = 0
      Object.keys(installments).map((v, i) => {
        arr.push(installments[i].price)
        toplam += parseFloat(installments[i].price)
      })
      this.form.installments = arr  
      this.installmentTotal =  toplam
    }
  },
};
</script>

<template>
  <b-modal 
        size="lg"
        id="modal-scoped"
        title="Tarife Ekle"  
        no-close-on-backdrop 
        hide-footer>
      <form @submit.prevent="handleSubmit">
        <div class="row">
          <div class="col-md-6">
            <div class="mb-2">
              <label for="type">Tarife Tipi</label>
              <select 
                class="form-control form-select"  
                :class="{
                    'is-invalid': submitted && $v.form.type.$error,
                  }" 
                v-model="form.type">
                  <option value="">Seçiniz</option>
                  <option value="ADSL">ADSL</option>
                  <option value="FIBER">FIBER</option>
                  <option value="WIFI">Wireless</option>
              </select>
              <div
                v-if="submitted && !$v.form.type.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="mb-2">
              <label for="invoice_type">Fatura Tipi</label>
              <select 
              :class="{
                  'is-invalid': submitted && $v.form.invoice_type.$error,
                }"
                v-model="form.invoice_type"
                class="form-control form-select">
                  <option value="">Seçiniz</option>
                  <option value="1">Ön Ödemeli</option>
              </select>
              <div
                v-if="submitted && !$v.form.invoice_type.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
          <div class="col-2"  v-if="form.invoice_type ==3">
            <div class="mb-2">
              <label for="time">Süresi</label>
              <select 
               :class="{
                  'is-invalid': submitted && $v.form.time.$error,
                }"
                v-model="form.time"
                class="form-control form-select">
                  <option value="12">12</option>
                  <option value="24">24</option>
                  <option value="36">36</option>
                  <option value="48">48</option>
              </select>
              <div
                v-if="submitted && !$v.form.time.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
          <div class="col-2"  v-if="form.invoice_type ==1 || form.invoice_type ==4">
            <div class="mb-2">
              <label for="time">Süresi</label>
              <select 
               :class="{
                  'is-invalid': submitted && $v.form.time.$error,
                }"
                v-model="form.time"
                class="form-control form-select">
                  <option 
                    v-for="i in 12"
                    :key="i">
                    {{ i }}
                    </option>
              </select>
              <div
                v-if="submitted && !$v.form.time.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="mb-2">
              <label for="behavior">Paket Birimi</label>
              <select 
               :class="{
                  'is-invalid': submitted && $v.form.unit.$error,
                }"
                v-model="form.unit"
                class="form-control form-select">
                  <option value="days">Gün</option>
                  <option value="months">Ay</option>
              </select>
              <div
                v-if="submitted && !$v.form.unit.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
          <div class="col-6">
            <div class="mb-2">
              <label for="hediye_ay">Hediye Ay</label>
              <select 
               :class="{
                  'is-invalid': submitted && $v.form.hediye_ay.$error,
                }"
                v-model="form.hediye_ay"
                class="form-control form-select">
                  <option value="0" selected>0</option>
                  <option value="1">+1</option>
                  <option value="2">+2</option>
                  <option value="3">+3</option>
                  <option value="4">+4</option>
                  <option value="5">+5</option>
                  <option value="6">+6</option>
              </select>
              <div
                v-if="submitted && !$v.form.hediye_ay.required"
                class="invalid-feedback"
              >
              Bu alanı doldurmak zorunludur.
              </div>
            </div>
          </div>
        </div>
        <div class="row" v-if="form.invoice_type ==3">
          <div class="col-4">
            <div class="mb-2">
              <label for="commitment_price">Taahütsüz Tarife Fiyatı</label>
              <input
              id="commitment_price"
              v-model="form.commitment_price"
              type="text"
              class="form-control"
              placeholder="Taahütsüz Fiyat"  
              :class="{
                  'is-invalid': submitted && $v.form.commitment_price.$error,
              }"
              />
              <div
              v-if="submitted && $v.form.commitment_price.$error"
              class="invalid-feedback"
              >
              <span v-if="!$v.form.commitment_price.required"
                  >Bu alanı doldurmak zorunludur.</span
              >
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="mb-2">
              <label for="promotion_period">İlk Kaç Ay Promosyon Olacak</label>
              <input
              id="promotion_period"
              v-model="form.promotion_period"
              type="text"
              class="form-control"
              placeholder="Promosyon Süresi"
              :class="{
                  'is-invalid': submitted && $v.form.promotion_period.$error,
              }"
              />
              <div
              v-if="submitted && $v.form.promotion_period.$error"
              class="invalid-feedback"
              >
              <span v-if="!$v.form.promotion_period.required"
                  >Bu alanı doldurmak zorunludur.</span
              >
              </div>
            </div>
          </div>
          <div class="col-4">
            <div class="mb-2">
              <label for="promotion_price">Promosyonda Geçerli Olacak Fiyat</label>
              <input
              id="promotion_price"
              v-model="form.promotion_price"
              type="text"
              class="form-control"
              placeholder="Promosyon Fiyatı"
              :class="{
                  'is-invalid': submitted && $v.form.promotion_price.$error,
              }"
              />
              <div
              v-if="submitted && $v.form.promotion_price.$error"
              class="invalid-feedback"
              >
              <span v-if="!$v.form.promotion_price.required"
                  >Bu alanı doldurmak zorunludur.</span
              >
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-2 mb-2">
             <label for="row_number">Sıra</label>
              <input
                id="row_number"
                v-model="form.row_number"
                type="number"
                class="form-control"
                placeholder="Sıra Numarası"
              />
          </div>
          <div class="col-10">
            <div class="mb-2">
              <label for="name">Tarife Adı</label>
              <input
              id="name"
              v-model="form.name"
              type="text"
              class="form-control"
              placeholder="Tarife Adı"
              :class="{
                  'is-invalid': submitted && $v.form.name.$error,
              }"
              />
              <div
              v-if="submitted && $v.form.name.$error"
              class="invalid-feedback"
              >
              <span v-if="!$v.form.name.required"
                  >Bu alanı doldurmak zorunludur.</span
              >
              </div>
            </div>
          </div>
        </div>
        <hr>
        <div class="row">
          <div class="col-md-6">
              <div class="mb-2">
                  <label for="upload_limit">Upload Hız Limiti</label>
                  <div class="input-group mb-2">
                    <input
                        id="upload_limit"
                        v-model="form.upload_limit"
                        type="text"
                        class="form-control"
                        placeholder="Upload Hız Limiti"
                        :class="{
                            'is-invalid': submitted && $v.form.upload_limit.$error,
                        }"
                        />
                      <div class="input-group-append">
                        <span class="input-group-text">Mbps</span>
                      </div>
                    </div>
                  <div
                  v-if="submitted && $v.form.upload_limit.$error"
                  class="invalid-feedback"
                  >
                  <span v-if="!$v.form.upload_limit.required"
                      >Bu alanı doldurmak zorunludur.</span
                  >
                  </div>
              </div>
          </div>
          <div class="col-md-6">
              <div class="mb-2">
                  <label for="download_limit">Download Hız Limiti</label>
                  <div class="input-group mb-2">
                  <input
                    id="download_limit"
                    v-model="form.download_limit"
                    type="text"
                    class="form-control"
                    placeholder="Download Hız Limiti"
                    :class="{
                        'is-invalid': submitted && $v.form.download_limit.$error,
                    }"
                    />
                    <div class="input-group-append">
                        <span class="input-group-text">Mbps</span>
                      </div>
                  </div>
                  <div
                  v-if="submitted && $v.form.download_limit.$error"
                  class="invalid-feedback"
                  >
                  <span v-if="!$v.form.download_limit.required"
                      >Bu alanı doldurmak zorunludur.</span
                  >
                  </div>
              </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="mb-2">
            <label for="download_rate">Patlama Max Hız (M)</label>
            <div class="d-flex justify-content-between">
              <div>
                Upload
              </div>
              <div>
                Download
              </div>
            </div>
            <div class="d-flex">
           
              <input
                id="upload_rate"
                v-model="burst.upload_rate"
                type="text"
                class="form-control"
                placeholder="Upload"
              />
              <input
                id="download_rate"
                v-model="burst.download_rate"
                type="text"
                class="form-control"
                placeholder="Download"
              />
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-2">
            <label for="download_threshold">Patlama Noktası (M)</label>
            <div class="d-flex justify-content-between">
              <div>
                Upload
              </div>
              <div>
                Download
              </div>
            </div>
            <div class="d-flex">
              <input
                id="upload_threshold"
                v-model="burst.upload_threshold"
                type="text"
                class="form-control"
                placeholder="Upload"
              />
              <input
                id="download_threshold"
                v-model="burst.download_threshold"
                type="text"
                class="form-control"
                placeholder="Download"
              />
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="mb-2">
            <label for="upload_time">Patlama Zamanı</label>
            <div class="d-flex justify-content-between">
              <div> - </div>
              <div>
                -
              </div>
            </div>
            <div class="d-flex">
              <input
                id="upload_time"
                v-model="burst.upload_time"
                type="text"
                class="form-control"
                placeholder="Upload Saniye"
              />
              <input
                id="upload_time"
                v-model="burst.download_time"
                type="text"
                class="form-control"
                placeholder="Download Saniye"
              />
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
            <div class="mb-2">
              <label >Tarife Fiyatı</label>
                  <input
                  id="price"
                  v-model="form.price"
                  type="text"
                  class="form-control"
                  placeholder="Müşteriden Alınacak Ücret"
                  :class="{
                      'is-invalid': submitted && $v.form.price.$error,
                  }"
                  />
                  <div
                  v-if="submitted && $v.form.price.$error"
                  class="invalid-feedback"
                  >
                  <span v-if="!$v.form.price.required"
                      >Bu alanı doldurmak zorunludur.</span
                  >
                  </div>
              </div>
          </div>
          
      <!--<div class="d-flex justify-content-center">
        <div class="col-md-12">
          <div class="table-responsive">
            <table class="table table-centered" style="border:dashed 1px #dedede">
              <thead>
                <tr>
                  <th colspan="2" scope="colgroup" class="text-center">Bayi Kazanç</th>
                  <th colspan="2" scope="colgroup" class="text-center">Hesaplama</th>
                </tr>
                 <tr>
                    <th scope="col">Fiyat Numarası</th>
                    <th scope="col" class="text-center" style="width:200px">Kazanç  %</th>
                    <th scope="col" class="text-end">Bayinin Kazancı</th>
                  </tr>
              </thead>
              <tbody>
                <tr v-for="(dataPrices,i) in dealerPrice" :key="i">
                   <td>
                      <select 
                          style="width:100%"
                          class="form-select"
                          v-model="dataPrices.index_num" 
                          >
                        <option 
                          :value="counter" 
                          v-for="counter in dealerPrice.length"  
                          :key="counter"
                         >
                          Bayi Fiyat {{ counter }}
                          </option>
                      </select>
                  </td>
                  <td>
                    <div class="input-group">
                      <span class="input-group-text"><span>%</span></span>
                      <input type="text" class="form-control" v-model="dataPrices.price" placeholder="%5"/>
                      <button  v-if="i>0" class="btn btn-outline-danger" type="button" @click="removeLine(i)">   
                        <i class="bx bx-trash-alt"></i>
                      </button>
                    </div>
                  </td>
                  <td class="text-end">
                    <span v-if="dataPrices.price > 0 && form.price > 0" >{{ (form.price/100) * dataPrices.price | fixed }} TL</span>
                    <span v-else> - </span>
                  </td>
                </tr>
              </tbody>
              <tfoot>
                <tr>
                  <td colspan=3 class="text-center p-0">
                      <button class="btn btn-sm btn-outline-default text-warning" type="button" @click="newLine">   
                        <i class="bx bx-plus"></i>Satır Ekle
                      </button>
                    </td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>
      </div>-->
          <div class="col-md-6">
              <label >Taksit <input type="checkbox" v-model="form.installmentCheck" value="1"></label>
              <table class="table table-bordered" v-if="form.installmentCheck">
                <tbody>
                  <tr v-for="(installment,i) in installments" :key="i">
                    <td style="width:75px;padding:0px;vertical-align:middle;text-align:center">
                      {{ i +1 }} . Taksit
                    </td>
                    <td style="padding:0px">
                        <div class="input-group">
                          <input type="text" class="form-control" @input="calc()" v-model="installment.price" />
                          <button  class="btn btn-outline-danger" type="button" @click="removeLine(i)">   
                            <i class="bx bx-trash-alt"></i>
                          </button>
                        </div>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td colspan=2 class="text-center p-0">
                        <button class="btn btn-sm btn-outline-default text-warning" type="button" @click="newLine">   
                          <i class="bx bx-plus"></i>Satır Ekle
                        </button>
                      </td>
                  </tr>
                  <tr>
                    <td colspan=2 >
                      Taksit Toplamı : {{ installmentTotal }}
                    </td>
                  </tr>
                </tfoot>
              </table>
          </div>
      </div>
       <div class="row">
        <div class="col-md-6">
            <div class="mb-2">
              <label >Durum</label>
                <input
                id="price"
                v-model="form.active"
                type="checkbox"
                />
              </div>
          </div>
      </div>
      <div class="d-flex justify-content-between mt-3">
        <div>
          <b-button variant="danger"  v-if="form.id" @click="remove(form.id)">Sil</b-button>
        </div>
        <div class="hstack gap-3">
          <b-button variant="light" @click="close()">Vazgeç</b-button>
          <b-button 
            v-if="form.id"
            type="submit" 
            variant="warning" 
            class="ms-1"
            >Güncelle
          </b-button>
          <b-button 
            v-else
            type="submit" 
            variant="success" 
            class="ms-1"
            >Oluştur
          </b-button>
        </div>
        </div>
      </form>
    </b-modal>
</template>  